import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { subscribePodcast, unsubscribePodcast } from '../../actions';
import { Button, message, Popconfirm } from 'antd';
import { fixedSpacing, colors, spacing } from '../../lib/theme';
import { showSubscriberCount } from '../../lib/utils';

class SubscriberCount extends Component {
    constructor(props) {
        super(props);
        this.state = { subscribed: undefined, loadingSubscribed: true, loadingConfirm: false };
    }

    render() {
        const { itunesId, podcast, dbPodcastState, subscribersFromParent } = this.props;
        // console.dir(dbPodcastState);
        const { loadingUserDetails, loadingPodcasts, loadingDBPodcastData } = this.props.loadingState;
        const loadingSubscribers = loadingDBPodcastData;
        let subscribers = 0;
        if (subscribersFromParent != null) {
            subscribers = subscribersFromParent;
        } else {
            subscribers = dbPodcastState[String(itunesId)] && dbPodcastState[String(itunesId)].subscribers || 0;
        }
        // console.dir(dbPodcastState);
        // console.dir(subscribers);

        let loadingSubscribed;
        if (loadingPodcasts || loadingUserDetails) {
            loadingSubscribed = true;
        } else {
            loadingSubscribed = false;
        }
        return (
            <div>
                {loadingSubscribed && <p>&hellip;</p>}

                {
                    !loadingSubscribed && <span><FontAwesomeIcon icon={['far', 'bookmark']} style={{ fontSize: '0.85em' }} />&nbsp;{loadingSubscribers ? '...' : showSubscriberCount(subscribers)}</span>
                }
                <style jsx>
                    {`
           :global(.btn-unsub) {
            background: hsl(0, 0%, 93.3%);
            color: hsla(0, 0%, 6.7%, .6);
            font-weight: 500;
           }
                `}
                </style>
            </div >
        )
    }
}

SubscriberCount.propTypes = {
    // userDetails: PropTypes.object,
    // subscribedPodcasts: PropTypes.object,
    loadingState: PropTypes.object,
    podcast: PropTypes.object,
    type: PropTypes.string,
    itunesId: PropTypes.number,
    loadingSubscribers: PropTypes.bool,
    loadingUserDetails: PropTypes.bool,
    loadingPodcasts: PropTypes.bool,
    showSubscribers: PropTypes.bool,
    dbPodcastState: PropTypes.object,
    loadingDBPodcastData: PropTypes.bool,
    subscribers: PropTypes.number,
    subscribersFromParent: PropTypes.number
}
SubscriberCount.defaultProps = {
    type: 'icon',
}

const mapStateToProps = (state) => {
    return {
        // userDetails: state.userDetails,
        loadingState: state.loadingState,
        dbPodcastState: state.dbPodcastState
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        // subscribePodcast: bindActionCreators(subscribePodcast, dispatch),
        // unsubscribePodcast: bindActionCreators(unsubscribePodcast, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SubscriberCount);
